import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PACKAGES } from "../data/siteContent";
import { scrollToId } from "../hooks/useLenis";

export default function Packages() {
  return (
    <section id="packages" data-testid="packages-section" className="py-20 sm:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Collections"
          title={
            <>
              Choose your <span className="italic text-gold">forever</span>
            </>
          }
          sub="Three curated collections, tailored to your celebration. Every wedding is quoted personally — no surprises, no hidden costs."
        />

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
          {PACKAGES.map((pkg, i) => (
            <Reveal key={pkg.id} delay={i * 0.12} className="h-full">
              <div
                data-testid={`package-card-${pkg.id}`}
                className={`relative h-full flex flex-col p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1.5 ${
                  pkg.featured
                    ? "bg-ink-elev border-2 border-gold/70 shadow-[0_0_60px_rgba(201,169,110,0.12)]"
                    : "bg-ink-soft/50 border border-white/[0.08] hover:border-gold/30"
                }`}
              >
                {pkg.featured && (
                  <span
                    data-testid={`package-featured-tag-${pkg.id}`}
                    className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-gold text-ink text-[10px] font-semibold uppercase tracking-[0.25em] px-5 py-2"
                  >
                    Most Loved
                  </span>
                )}

                <h3 className="font-display text-3xl text-ivory">{pkg.name}</h3>
                <p className="text-[11px] uppercase tracking-[0.25em] text-gold mt-1.5 mb-7">
                  {pkg.subtitle}
                </p>

                <p className="font-display italic text-2xl text-ivory-dim mb-7" data-testid={`package-price-${pkg.id}`}>
                  Contact for quote
                </p>

                <ul className="flex-1 space-y-3.5 mb-9">
                  {pkg.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-ivory-dim leading-relaxed">
                      <Check className="w-4 h-4 text-gold mt-0.5 shrink-0" strokeWidth={2.4} />
                      {f}
                    </li>
                  ))}
                </ul>

                <button
                  data-testid={`package-cta-${pkg.id}`}
                  onClick={() => scrollToId("book")}
                  className={`w-full flex items-center justify-center gap-2 text-[12px] font-semibold uppercase tracking-[0.22em] py-4 transition-all duration-300 ${
                    pkg.featured
                      ? "bg-gold text-ink hover:bg-gold-hover"
                      : "border border-gold/40 text-gold hover:bg-gold hover:text-ink"
                  }`}
                >
                  Request Custom Quote
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
